export const resetGetStyles = () => ({});
